import React, { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { companyAtom } from '../../_atoms/company';
import { userAtom } from '../../_atoms/user';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../components/bootstrap/Modal';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Input from '../../components/bootstrap/forms/Input';
import Button from '../../components/bootstrap/Button';
import Label from '../../components/bootstrap/forms/Label';
import Icon from '../../components/icon/Icon';
import { useTranslation } from 'react-i18next';
import { getPayTrToken } from '../../_services/paytr';
import { numberFormat } from '../../helpers/formats';
import Select from '../../components/bootstrap/forms/Select';
import { Options } from '../../components/bootstrap/Option';

const PaymentDialog = ({ open, toggle, base }) => {
  const [user] = useAtom(userAtom)
  const [company] = useAtom(companyAtom)
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState(user?.email || '')
  const [identityNumber, setIdentityNumber] = useState('')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [zipCode, setZipCode] = useState('')
  const [phone, setPhone] = useState(user?.phone || '')
  const [ip, setIp] = useState('')
  const [payTrToken, setPayTrToken] = useState('')
  const [months, setMonths] = useState(1)
  const [price, setPrice] = useState(0)

  useEffect(() => {
    setPrice(base * months)
  }, [months, base])

  useEffect(() => {
    const getUserIp = async () => {
      try {
        const res = await fetch('https://geolocation-db.com/json/');
        const data = await res.json();
        setIp(data.IPv4);
      } catch (err) {
        setIp('');
      }
    };
    getUserIp();
  }, []);

  const handleClose = () => {
    setEmail(user?.email || '')
    setIdentityNumber('')
    setAddress('')
    setCity('')
    setZipCode('')
    setPhone(user?.phone || '')
    setMonths(1)
    setPrice(base)
    setPayTrToken('')
    toggle()
  };

  const handlePayTrToken = async () => {
    // Basic validation örneği
    if (!ip || !email || !user.firstname || !user.familyname || !address || !city) {
      // Burada formik ile daha gelişmiş validasyon entegre edebilirsin
      alert("dsadadsa")
      return;
    }

    const data = {
      user_params: {
        user_ip: ip,
        user_name: `${user.firstname} ${user.familyname}`,
        user_address: `${address} ${zipCode} ${city}`,
        user_phone: phone.toString() || "5111111111",
        user_basket: [{ urun_adi: "OxyFitClub Aylık Abonelik", urun_fiyat: price, urun_adet: months }],
        email: email.trim().replace(' ', ''),
        payment_amount: price,
        currency: 'TL',
        merchant_ok_url: 'https://oxyfitclub.com/odeme-basarili',
        merchant_fail_url: 'https://oxyfitclub.com/odeme-hata',
      },
      panelUser: user._id,
      company,
      price,
      months,
    };
    setLoading(true)
    try {
      const res = await getPayTrToken(data)
      console.log(res.data)
      setLoading(false)
      if (res.data && res.data.code === 200) {
        setPayTrToken(res.data.data)
      }
    } catch (err) {
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={open} setIsOpen={toggle} size="lg">
      <ModalHeader>
        <div className="d-flex align-items-center w-100">
          <Icon icon="CreditCard" className="me-2" />
          <h4>Abonelik Ödeme - {numberFormat(price)}₺</h4>
        </div>
      </ModalHeader>
      <ModalBody>
        {payTrToken ? (
          <div className="d-flex justify-content-center">
            <iframe
              src={`https://www.paytr.com/odeme/guvenli/${payTrToken}`}
              frameBorder="no"
              className="w-100"
              style={{ minHeight: 700 }}
              title="Ödeme"
            />
          </div>
        ) : (
          <>
            <Label>{"Abonelik için gerekli bilgileri doldurun."}</Label>
            <div className="row g-4">
              <div className="col-12 col-md-6">
                <FormGroup id="price" isFloating label={"Tutar"}>
                  <Input
                    id="price"
                    type="number"
                    value={price}
                    disabled
                  />
                </FormGroup>
              </div>
              <div className="col-12 col-md-6">
                <FormGroup id="months" isFloating label={"Kaç Aylık"}>
                  <Select
                    value={months}
                    onChange={e => setMonths(Number(e.target.value) || 1)}
                  >
                    <Options list={[
                      { value: 1, label: 1 },
                      { value: 2, label: 2 },
                      { value: 3, label: 3 },
                      { value: 4, label: 4 },
                      { value: 5, label: 5 },
                      { value: 6, label: 6 },
                      { value: 8, label: 8 },
                      { value: 12, label: 12 },
                    ]} />
                  </Select>
                </FormGroup>
              </div>
              <div className="col-12 col-md-6">
                <FormGroup id="email" isFloating label={t("common.email")}>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </FormGroup>
              </div>
              <div className="col-12 col-md-6">
                <FormGroup id="identityNumber" isFloating label={ "TC Kimlik No"}>
                  <Input
                    id="identityNumber"
                    value={identityNumber}
                    onChange={e => setIdentityNumber(e.target.value)}
                  />
                </FormGroup>
              </div>
              <div className="col-12 col-md-6">
                <FormGroup id="phone" isFloating label={"Telefon"}>
                  <Input
                    id="phone"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                  />
                </FormGroup>
              </div>
              <div className="col-12 col-md-6">
                <FormGroup id="zipCode" isFloating label={"Posta Kodu"}>
                  <Input
                    id="zipCode"
                    value={zipCode}
                    onChange={e => setZipCode(e.target.value)}
                  />
                </FormGroup>
              </div>
              <div className="col-12">
                <FormGroup id="address" isFloating label={t("common.address")}>
                  <Input
                    id="address"
                    value={address}
                    onChange={e => setAddress(e.target.value)}
                  />
                </FormGroup>
              </div>
              <div className="col-12">
                <FormGroup id="city" isFloating label={t("common.city")}>
                  <Input
                    id="city"
                    value={city}
                    onChange={e => setCity(e.target.value)}
                  />
                </FormGroup>
              </div>
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="row g-2 w-100">
          <div className="col-6">
            <Button
              color='danger'
              className='w-100'
              icon='close'
              isLight
              onClick={handleClose}
            >
              {t("common.close")}
            </Button>
          </div>
          <div className="col-6">
            {payTrToken ? null : (
              <Button
                color='success'
                className='w-100'
                isLight
                isDisable={loading || !(price > 10)}
                onClick={handlePayTrToken}
                icon='Check'
              >
                {loading
                  ? "Yükleniyor..."
                  : (`Ödeme Yap - ${new Intl.NumberFormat().format(price)}₺`)}
              </Button>
            )}
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default PaymentDialog;
